import React from "react";
const HEXThumbsUp = () => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="#11387F">
      <g clipPath="url(#clip0_1_2)">
        <path
          d="M6.32 10.5V21.5M6.32 10.5H1V21.5H14.82C15.7249 21.5006 16.6032 21.1943 17.3115 20.6313C18.0199 20.0682 18.5164 19.2817 18.72 18.4L21 8.5H13V1.5H10L6.32 10.5Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="22" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default HEXThumbsUp;
